import axios from "axios"
import { baseUrl, requestID, config } from "../common/utils"

export const createProject = async (formData: FormData): Promise<{ success: boolean; message: string }> => {

   try {
    const response = await axios.post(`${baseUrl()}projects/addMyProject`, formData, config)
    for (const key of formData.keys()) {
      console.log(key, formData.get(key))
    }

    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value)
    }
       
    console.log("Create project response:", response)
    // Check if the API call was successful
    if (response.data && response.data.status) {
      return {
          success: true,
            message: response.data.message || "Project created successfully",
      }
    } else {
      throw new Error(response.data.message || "Failed to create project")
      console.error("API Error:", response.data.message)
    }
  } catch (error: any) {
    console.error("Error creating project:", error)

    // Handle specific API error messages
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }

    throw new Error("Failed to create project")
  }
}

export const allProjects = async (): Promise<{ message: string; response: any[]}> => {

   try {
       const response = await axios.post(`${baseUrl()}projects/getProjectByBusinessOwnerId`, {
        requestID: requestID(),
        // userId: getUser()?.id,
       }, config)

       console.log("Get all projects response:", response)

       // Check if the API call was successful
       if (response.data) {
         return {
             response: response.data.data,
               message: response.data.message || "Projects fetched successfully",
         }
       } else {
         throw new Error(response.data.message || "Failed to create project")
       }
    console.log("Create project response:", response)

    
  } catch (error: any) {
    console.error("Error creating project:", error)

    // Handle specific API error messages
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }

    throw new Error("Failed to create project")
  }
}

export const addJobRoles = async (formData): Promise<{ message: string; response: any[]}> => {

   try {
     const response = await axios.post(`${baseUrl()}projects/createJobRole`, {
        ...formData,
        requestID: requestID(),
       }, config)

       console.log("Get all projects response:", response)

       // Check if the API call was successful
       if (response) {
         return {
             response: response.data.data,
               message: response.data.message || "Projects fetched successfully",
         }
       } else {
         throw new Error(response.data.message || "Failed to create project")
       }
  } catch (error: any) {
    console.error("Error creating project:", error)

    // Handle specific API error messages
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }

    throw new Error("Failed to create project")
  }
}

export const getJobRolesById = async (projectId: string): Promise<{ message: string; response: any[]}> => {

   try {
     const response = await axios.post(`${baseUrl()}projects/getJobRolesByProjectId`, {
        project_id: projectId,
        requestID: requestID(),
       }, config)

       console.log("Get all projects response:", response)

       // Check if the API call was successful
       if (response) {
         return {
             response: response.data.data,
             message: response.data.status || "Projects fetched successfully",
         }
       } else {
         throw new Error(response.data.message || "Failed to create project")
       }
  } catch (error: any) {
    console.error("Error creating project:", error)

    // Handle specific API error messages
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }

    throw new Error("Failed to create project")
  }
}

export const allProjectsByHr = async (): Promise<{ message: string; response: any[]}> => {

   try {
       const response = await axios.post(`${baseUrl()}projects/getAllProjects`, {
        requestID: requestID(),
        // userId: getUser()?.id,
       }, config)

       console.log("Get all projects response:", response)

       // Check if the API call was successful
       if (response.data) {
         return {
             response: response.data.data,
               message: response.data.message || "Projects fetched successfully",
         }
       } else {
         throw new Error(response.data.message || "Failed to create project")
       }
    console.log("Create project response:", response)

    
  } catch (error: any) {
    console.error("Error creating project:", error)

    // Handle specific API error messages
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message)
    }

    throw new Error("Failed to create project")
  }
}
export const getAllEmployees_active = async () => {
  try {
    const response = await axios.post(`${baseUrl()}/businesss/getAllStaffs2_hr_consulting_active`, {
    // const response = await axios.post("/api/Users/getAllUserData", {
      requestID: requestID(),
    }, config)
    console.log("Get all employees response:", response)
    return response.data.data
    
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}

export const getAllEmployees = async () => {
  try {
    const response = await axios.post(`${baseUrl()}/businesss/getAllStaffs2_hr_consulting_active`, {
    // const response = await axios.post("/api/Users/getAllUserData", {
      requestID: requestID(),
    }, config)
    console.log("Get all employees response:", response)
    return response.data.data
    
  } catch (error) {
    console.error("Error fetching employees:", error)
    throw new Error("Failed to fetch employees")
  }
}

export const getAllAssignments = async () => {
  try {
    const response = await axios.post(`${baseUrl()}projects/getAllAssignments`, {
      requestID: requestID(),
    }, config)
    console.log("Get all assignments response:", response.data)
    return response.data
    
  } catch (error) {
    console.error("Error fetching assignments:", error)
    throw new Error("Failed to fetch assignments")
  }
}

export const getStaffAssignments = async () => {
  try {
    const response = await axios.post(`${baseUrl()}projects/getMyAssignments`, {
      requestID: requestID(),
    }, config)
    console.log("Get all assignments response:", response)
    return response.data
    
  } catch (error) {
    console.error("Error fetching assignments:", error)
    throw new Error("Failed to fetch assignments")
  }
}